import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';

export default class Navigation
extends React.Component {
	state = {};

	render () {
		const { active } = this.state;

		const LinkItem = ({ activeSlug, label, to }) => (
			<NavLink
				className={ active === activeSlug ? 'active' : '' }
				onClick={ () => { this.setState({active: activeSlug}) } }
				exact to={ to }
			>
				{ label }
			</NavLink>
		);

		return (
			<Fragment>
				<div className="grid-x">
					<div className="cell auto">
						<nav>
							<ul className="menu horizontal artist-nav">
								<li>
									<LinkItem
										label="Library"
										activeSlug="library"
										to="/my-music/library"
									/>
								</li>
								<li>
									<LinkItem
										label="Albums"
										activeSlug="Albums"
										to="/my-music/albums"
									/>
								</li>
								<li>
									<LinkItem
										label="Favorites"
										activeSlug="my-hi-fives"
										to="/my-music/my-hi-fives"
									/>
								</li>
								{/*TODO: Turn this back on and implement later*/ }
								{/* <li>
									<LinkItem
										label="New Releases"
										activeSlug="new-releases"
										to="/my-music/new-releases"
									/>
								</li> */}
							</ul>
						</nav>
					</div>
				</div>
			</Fragment>
		);
	}
}
